<template>
  <div>
    <div
      v-for="(variant, index) in productVariants"
      :key="variant.productReference"
    >
      <p v-if="index != 0" class="text-muted">
        <em>{{ dictionary.or }}</em>
      </p>

      <quantity-field
        :product="variant"
        :unit="variant.price.unit"
        :disabled="variant.disabled"
        :quantity="quantity"
        :closest-plant="closestPlant"
        v-on:adding-to-cart="disableVariantsExcept"
      />
    </div>

    <p class="small m-0">
      {{ dictionary.deliveryMessage }}
    </p>
  </div>
</template>

<script>
import QuantityField from "./quantity-field.vue";
import { GetTranslations } from "../services/translation.service";

export default {
  name: "QuantityFieldCollection",
  props: {
    quantity: {
      type: Number,
      required: false,
    },
    variants: {
      type: Array,
      required: true,
    },
    closestPlant: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      productVariants: { ...this.variants },
      dictionary: GetTranslations("addToCart"),
    };
  },
  methods: {
    disableVariantsExcept(productReference) {
      this.productVariants = this.variants.map((variant) => {
        if (variant.productReference != productReference) {
          variant.disabled = true;
        }
        return variant;
      });
    },
    enableAllVariants() {
      this.productVariants = this.variants.map((variant) => {
        variant.disabled = false;
        return variant;
      });
    },
  },
  components: {
    QuantityField,
  },
};
</script>